import { Injectable } from '@angular/core';
import { SETTINGS } from '../configs/common.settings';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient, private router: Router) { }

  createUser(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/user/create`, payload);
  }

  getPagedUsers(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/user/get-paged`, payload);
  }

  getFilteredUsers(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/user/get-filtered`, payload);
  }
  getAllActiveUsers(): Observable<any> {
    return this.http.get(`${SETTINGS.BASE_API}/user/get-all-active`);
  }
  getSalesRepresentatives(): Observable<any> {
    return this.http.get(`${SETTINGS.BASE_API}/user/sales-representatives`);
  }
  deleteUser(id: any): Observable<any> {
    return this.http.delete(`${SETTINGS.BASE_API}/user/delete/${id}`);
  }

  userById(id: any): Observable<any> {
    return this.http.get(`${SETTINGS.BASE_API}/user/user/${id}`);
  }

  resendCredentials(payload: any): Observable<any> {
    return this.http.post(
      `${SETTINGS.BASE_API}/user/resend-credential`,
      payload
    );
  }

  updateUser(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/user/update`, payload);
  }

  changeRole(
    id: string,
    body: { roleId: string; templateId?: string | null; resetOverrides?: boolean }
  ): Observable<any> {
    return this.http.put(`${SETTINGS.BASE_API}/user/${id}/role`, body);
  }

  userDetailsById(id: any): Observable<any> {
    return this.http.get(`${SETTINGS.BASE_API}/user/${id}`);
  }

  /** CR-69 — pay periods for Timesheet tab accordion. */
  getTimesheetPeriods(
    id: string,
    page = 1,
    pageSize = 10
  ): Observable<{
    items: Array<{ start: string; end: string; label: string; isCurrent: boolean }>;
    total: number;
    page: number;
    pageSize: number;
    payrollCycle?: string;
    startDate?: string;
  }> {
    return this.http.get<{
      items: Array<{ start: string; end: string; label: string; isCurrent: boolean }>;
      total: number;
      page: number;
      pageSize: number;
      payrollCycle?: string;
      startDate?: string;
    }>(`${SETTINGS.BASE_API}/user/${id}/timesheet-periods`, {
      params: { page: String(page), pageSize: String(pageSize) },
    });
  }
}
